<template>
  <div v-if="visible" class="fullscreen-image-viewer" @touchmove.prevent>
    <div class="header">
      <div class="close-btn" @click="handleClose">
        <img src="@/assets/icons/closer.svg" alt="关闭" />
      </div>
      <div class="page-indicator">
        {{ currentIndex + 1 }}/{{ images.length }}
      </div>
      <div
        v-if="currentIndex > 0 && showDeleteBtn"
        class="delete-btn"
        @click="handleDelete"
      >
        <img src="@/assets/icons/trash.svg" alt="删除" />
      </div>
      <div v-else class="delete-btn-placeholder"></div>
    </div>
    <div class="image-container">
      <van-swipe
        ref="imageSwipe"
        v-model="currentIndex"
        class="image-swiper"
        :show-indicators="false"
        :initial-swipe="initialSwipeIndex"
        @change="onSwipeChange"
        @touchstart.stop
        @touchmove.stop
        @touchend.stop
      >
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <div class="image-wrapper">
            <img :src="image" class="main-image" @click="handleImageClick" />
          </div>
        </van-swipe-item>

        <template #indicator>
          <div v-if="images.length > 1" class="custom-indicators">
            <div
              v-for="(image, index) in images"
              :key="index"
              class="indicator-dot"
              :class="{ active: index === currentIndex }"
            ></div>
          </div>
        </template>
      </van-swipe>
    </div>
    <div v-if="showUploadBtn" class="bottom-actions">
      <div class="upload-btn" @click="handleUpload">上传图片</div>
    </div>
    <CConfirm ref="refCConfirm" />
  </div>
</template>

<script>
  import CConfirm from './CConfirm.vue'

  export default {
    name: 'ImageViewer',
    components: {
      CConfirm
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      images: {
        type: Array,
        default: () => []
      },
      initialIndex: {
        type: Number,
        default: 0
      },
      showDeleteBtn: {
        type: Boolean,
        default: false
      },
      showUploadBtn: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        currentIndex: 0,
        initialSwipeIndex: 0
      }
    },
    watch: {
      visible(newVal) {
        if (newVal) {
          this.currentIndex = this.initialIndex
          this.initialSwipeIndex = this.initialIndex
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      },
      initialIndex(newVal) {
        this.currentIndex = newVal
        this.initialSwipeIndex = newVal
      }
    },
    methods: {
      handleClose() {
        this.$emit('close')
      },
      handleImageClick() {
        console.log('Image clicked')
      },
      async handleDelete() {
        if (this.images.length === 0) return
        try {
          await this.$refs.refCConfirm.show('确定删除这张照片吗？')
          this.$emit('delete', this.currentIndex)
          if (this.images.length <= 1) {
            this.handleClose()
          } else if (this.currentIndex >= this.images.length - 1) {
            this.currentIndex = this.images.length - 2
          }
        } catch (error) {
          // 用户取消删除，不做任何操作
        }
      },
      handleUpload() {
        this.$emit('upload')
      },
      onSwipeChange(index) {
        this.currentIndex = index
        this.$emit('change', index)
      }
    },
    beforeDestroy() {
      // 组件销毁时恢复页面滚动
      document.body.style.overflow = ''
    }
  }
</script>

<style lang="less" scoped>
  .fullscreen-image-viewer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: var(--dynamic-vh);
    background-color: #ffffff;
    z-index: 9999;
    display: flex;
    flex-direction: column;

    .header {
      position: relative;
      height: 85/20rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20/20rem;
      padding-top: 44/20rem; // 状态栏高度

      .close-btn {
        width: 28/20rem;
        height: 28/20rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .page-indicator {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        font-family: 'SF Pro Text';
        font-weight: 600;
        font-size: 18/20rem;
        line-height: 21/20rem;
        text-align: center;
        color: #000000;
      }

      .delete-btn {
        width: 20/20rem;
        height: 20/20rem;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .delete-btn-placeholder {
        width: 20/20rem;
        height: 20/20rem;
      }
    }

    .image-container {
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .image-swiper {
        height: 488/20rem;

        .image-wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .main-image {
            width: 100%;
            object-fit: contain;
            display: block;
          }
        }
      }

      .custom-indicators {
        position: absolute;
        bottom: 20/20rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;

        .indicator-dot {
          width: 30/20rem;
          height: 2/20rem;
          background-color: rgba(0, 0, 0, 0.16);

          &.active {
            background-color: #000000;
          }
        }
      }
    }

    .bottom-actions {
      position: relative;

      .upload-btn {
        height: 46/20rem;
        margin: 8/20rem 20/20rem 60/20rem;
        background-color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'PingFang TC';
        font-weight: 400;
        font-size: 16/20rem;
        line-height: 24/20rem;
        color: #ffffff;
        cursor: pointer;

        &:active {
          background-color: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
</style>
